<template>
    <div class="w-full flex flex-col">
        <div class="pt-6">

            <h2 class="text-2xl lg:text-3xl font-bold text-theme-primary mb-2 text-left">PIN Verification</h2>
            <p class="mb-5 text-left text-base">Please enter your Personal Identification Number (PIN) to proceed.</p>

            <div class="w-full flex flex-row justify-center my-4">
                <v-otp-input :is-disabled="false" ref="pinOTP" input-classes="otp-input" :input-type="pin_type"
                    inputmode="numeric" :num-inputs="6" v-model:value="pin_value" :should-auto-focus="true"
                    :should-focus-order="true" :key="otpInputKey" @on-complete="validatePIN" @on-change="changePIN" />
                <div class="otp-input flex justify-center items-center text-center bg-gray-100 cursor-pointer"
                    @click="togglePeeker()">
                    <Icon :source="getImgSrc()" :width="24" />
                </div>
            </div>

            <div v-if="pin_error_message" class="w-full flex items-center justify-center text-center mt-3">
                <div class="text-red-500 text-center bg-red-100 px-4 py-2 rounded-full font-medium text-base"
                    v-text="pin_error_message" />
            </div>
        </div>
    </div>
</template>


<script>
import { defineComponent } from "vue";
import mixin from "@/mixin";
import User from "@/services/User";
import VOtpInput from "vue3-otp-input";
import Icon from "../controls/Icon.vue";

export default defineComponent({
    mixins: [mixin],
    inject: ['setLoading'],
    components: {
        VOtpInput,
        Icon
    },
    data() {
        return {
            pin_type: 'password',
            visible_pin: false,
            pin_value: '',
            pin_error_message: '',
            otpInputKey: 0,
        }
    },
    props: {

    },
    methods: {
        togglePeeker() {
            if (this.pin_type == 'password') {
                this.visible_pin = true;
                this.pin_type = 'number';
            } else {
                this.visible_pin = false;
                this.pin_type = 'password';
            }
        },
        getImgSrc() {
            return this.visible_pin ? "images/papsi_vis_icon.svg" : "images/papsi_invi_icon.svg";
        },
        changePIN() {
            this.pin_error_message = '';
        },
        validatePIN() {
            let that = this;
            const cookie = that.$cookies;
            let pin_payload = {
                hash: cookie.get('user_session').hash,
                pin: that.pin_value
            }

            that.setLoading(true);
            that.show_message_modal = false;
            User.validateOldPin(cookie.get('user').uuid, pin_payload)
                .then(() => {
                    this.$emit('validated');
                })
                .catch((error) => {
                    this.setLoading(false);

                    if (error.response?.status === 403) {
                        this.expired = true;
                        this.$store.state.logged = false;
                        this.pin_error_message = "Your session has expired. Please log in again.";
                    } else {
                        this.pin_error_message =
                            error.response?.data?.message ||
                            error.message ||
                            "An error occurred.";
                    }

                    this.otpInputKey++;
                    this.pin_value = "";
                });
        },
    },

})
</script>
<style scoped></style>